var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);

var FirstButton = createReactClass({
    mixins: [PureRenderMixin],

	render: function(){
        var firstButton = this.props.firstButton;
        var renderNode = null;

        if(firstButton && firstButton.url){
            renderNode = <LinkWrapper to={firstButton.url} className={'button success ' + (this.props.size ? this.props.size : '')} handler={this.props.clickTracking}>{firstButton.label}</LinkWrapper>;

            switch(this.props.withContainer){
                case 'div':
                    renderNode = <div>{renderNode}</div>;
                break;

                // switch comparison is strict, so don't worry mistake match here
                case false:
                    // explicit set withContainer={false} to disable wrap container
                break;

                default:
                    renderNode = <p>{renderNode}</p>;
            }
        }

		return renderNode;
	}
});

module.exports = FirstButton;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/firstButton.jsx